import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["inputField", "textDisplay"];

  connect() {
    this.isReadOnly = this.data.get("readOnly") === "true";
    this.inputFieldTarget.addEventListener("keypress", this.handleKeyPress.bind(this))
  }

  edit(event) {
    if (this.isReadOnly) return;

    const displayElement = this.textDisplayTarget;
    const inputElement = this.inputFieldTarget;

    displayElement.style.display = "none"; // Hide email display
    inputElement.style.display = "block";  // Show email input field
    inputElement.focus(); // Focus on input
  }

  handleKeyPress(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.inputFieldTarget.blur();
    }
  }

  save(event) {
    if (event.type === "keydown" && event.key !== "Enter") return;

    const inputElement = this.inputFieldTarget;
    const displayElement = this.textDisplayTarget;
    const newValue = inputElement.value.trim();

    // Do nothing, if value not changed.
    // if (inputElement.value === inputElement.defaultValue) return;

    // Validate email format using the provided pattern
    const emailPattern = /(^[^@]+@[^@]+$)|^(\{[\{|%][^\\{]*\})$/;
    if (!emailPattern.test(newValue)) {
      alert("Please enter a valid email address.");
      return;
    }

    const { accountId, projectId, taskListId, taskId, blockId } = this.element.dataset;

    fetch(`/${accountId}/projects/${projectId}/task_lists/${taskListId}/tasks/${taskId}/task_blocks/${blockId}/update_content`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ task_block: { value: newValue } })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          if (data.value) {
            displayElement.innerHTML = `<a href="mailto:${data.value}">${data.value}</a>`;
          } else {
            displayElement.textContent = "Click to edit";
          }
        }
      })
      .catch(error => console.error("Error updating block:", error))
      .finally(() => {
        inputElement.style.display = "none";
        displayElement.style.display = "flex";
      });
  }
}
